import React from 'react'
import HomeServices from './HomeServices'
// import HomeAbout from './HomeAbout'
// import HomeDumping from './HomeDumping'
import HomeBanner from './HomeBanner'
import HomeSolutions from './HomeSolutions'
import HomeCircleLogos from './HomeCircleLogos'
import HomeTestimonial from './HomeTestimonial'
import HomeChoose from './HomeChoose'
import HomeLogos from './HomeLogos'
import HomeInsight from './HomeInsight'
import HomeFaq from './HomeFaq'
import HomeWork from './HomeWork'
import HomeLocation from './HomeLocation'
import HomeBooking from './HomeBooking'
import PricingSustainbilty from '../pricingPage/PricingSustainbilty'
import ServiceFeatures from '../servicesPages/Services/ServiceFeatures'
// import HomeWorks from './HomeWorks'

export default function Home({ initialData }) {

  // const rentalsData = [
  //   {
  //     id: "001",
  //     title: "Real Estate & Property",
  //     img: "/assets/images/splite-icons1.webp",
  //     desc: "We help property managers maintain clean, attractive buildings with fast, reliable waste services always available."
  //   },
  //   {
  //     id: "002",
  //     title: "Construction Industry",
  //     img: "/assets/images/splite-icons2.webp",
  //     desc: "Reliable dumpster rentals for construction projects, ensuring efficient debris removal and smooth site operations."
  //   },
  //   {
  //     id: "003",
  //     title: "Retail & Hospitality",
  //     img: "/assets/images/splite-icons3.webp",
  //     desc: "Stores to hotels, BigBin Rentals ensures waste is managed efficiently, maintaining spotless, welcoming spaces."
  //   },
  //   {
  //     id: "004",
  //     title: "Landscaping & Renovation",
  //     img: "/assets/images/splite-icons4.webp",
  //     desc: "Ideal for yard cleanups and renovations, providing convenient bin rentals to manage soil, green waste, and debris efficiently."
  //   }
  // ];




  // const HomeService = {
  //   title: "Choose Your Pick from Our Different Dumpster Sizes",
  //   description: "From small home cleanups to large construction projects, Big Bin offers a range of dumpster sizes designed to handle waste efficiently and fit your specific requirements.",
  //   services: [
  //     {
  //       title: "12 Yard Dumpster",
  //       size: "14' L × 3.09' H × 4.5' W",
  //       bags: "$279",
  //       image: "/assets/images/services-image1.webp",
  //     },
  //     {
  //       title: "20 Yard Dumpster ",
  //       size: "14' L × 5' H × 7.5' W",
  //       bags: "$340 ",
  //       image: "/assets/images/services-image2.webp",
  //     },

  //     {
  //       title: "20 Yard Dumpster <br> (With Lid)",
  //       size: "14' L × 5' H × 7.5' W",
  //       bags: "$389",
  //       image: "/assets/images/services-image3.webp",
  //     },


  //     {
  //       title: "25 Yard Dumpster",
  //       size: "14' L × 3.09' H × 4.5' W",
  //       bags: "$399",
  //       image: "/assets/images/services-image4.webp",
  //     }
  //   ],
  // };


  const HomeService = {
    title: "Choose Your Pick from Our Different Dumpster Sizes",
    description: "From small home cleanups to large construction projects, BigBin offers a range of dumpster sizes designed to handle waste efficiently and fit your specific requirements.",
    services: [
      {
        title: "6 Cubic Yards",
        ton: "1 Ton ",
        size: "12' long x 7' wide x 2' high",
        bags: "Concrete Bin only",
        image: "/assets/images/new-dumpster-size-img1.webp",
        btn: "Book Online",
        btn2: "Pricing",
        bnt2link: "/pricing/"
      },
      {
        title: "12 Cubic Yards",
        size: "12' long x 7' wide x 4' high",
        ton: "1 Ton ",
        bags: "50-70 trash bags",
        image: "/assets/images/new-dumpster-size-img2.webp",
        btn: "Book Online",
        btn2: "Pricing",
        bnt2link: "/pricing/"
      },


      {
        title: "15 Cubic Yards",
        size: "14' long x 6.75' wide x 4.95' high",
        ton: "1 Ton ",
        bags: "60-85 trash bags",
        image: "/assets/images/new-dumpster-size-img3.webp",
        btn: "Book Online",
        btn2: "Pricing",
        bnt2link: "/pricing/"
      },

      {
        title: "20 Cubic Yards",
        size: "14' long x 7.5' wide x 5' high",
        ton: "1 Ton ",
        bags: "80-100 trash bags",
        image: "/assets/images/new-dumpster-size-img4.webp",
        btn: "Book Online",
        btn2: "Pricing",
        bnt2link: "/pricing/"
      },

      {
        title: "25 Cubic Yards",
        size: "14' long x 7.9' wide x 6.25' high",
        ton: "1 Ton ",
        bags: "110-130 trash bags",
        image: "/assets/images/new-dumpster-size-img5.webp",
        btn: "Book Online",
        btn2: "Pricing",
        bnt2link: "/pricing/"
      },



      {
        title: "Are you  a business?",
        size: "",
        ton: "1 Ton ",
        bags: "",
        image: "/assets/images/new-dumpster-size-img6.webp",
        btn: "Get A Custom Quote",
        btn2: "Call Us +1 780 230 1359",
        bnt2link: "tel: Call Us +1 780 230 1359",
        isBusiness: true 
      }
    ]
  };


  const homeWorkData = [
    {
      icon: "/assets/images/works-new-icon1.webp",
      title: "Find the Right Dumpster for Your Project",
      desc: "Tell us about your project, and we’ll recommend the ideal dumpster size and delivery option.",
      number: "/assets/images/works-number1.webp",
      step: "Step 1",
      link: "/contact-us/"
    },
    {
      icon: "/assets/images/works-new-icon2.webp",
      title: "Set a Date and Pick a Delivery Spot",
      desc: "Let us know when and where you’d like your dumpster delivered for convenient, on-time service.",
      number: "/assets/images/works-number2.webp",
      step: "Step 2",
      link: "/contact-us/"
    },
    {
      icon: "/assets/images/works-new-icon3.webp",
      title: "Get Your Dumpster On  <br> Time",
      desc: "On delivery day, your dumpster arrives exactly at your selected location, ready for immediate use.",
      number: "/assets/images/works-number3.webp",
      step: "Step 3",
      link: "/contact-us/"
    },

    {
      icon: "/assets/images/works-new-icon4.webp",
      title: "Fill Your Dumpster and Schedule Pickup",
      desc: "When you finish loading, schedule a convenient pickup day that fits your timeline perfectly.",
      number: "/assets/images/works-number4.webp",
      step: "Step 4",
      link: "/contact-us/"
    },
    {
      icon: "/assets/images/works-new-icon5.webp",
      title: "Timely Pickup & Responsible Disposal",
      desc: "Once your bin rental is full, schedule a pickup at your convenience. We ensure prompt collection and eco-friendly disposal of your waste.",
      number: "/assets/images/works-number4.webp",
      step: "Step 5",
      link: "/contact-us/"
    },

    {
      icon: "/assets/images/works-new-icon6.webp",
      title: "Upfront Pricing, No <br> Surprises",
      desc: "Your project wraps up with transparent, upfront pricing and responsible disposal.",
      number: "/assets/images/works-number4.webp",
      step: "Step 6",
      link: "/contact-us/"
    }

  ];

  const CircleLogos = [
    {

      img: "/assets/images/circle-logo1.webp",
    },
    {

      img: "/assets/images/circle-logo2.webp",
    },
    {

      img: "/assets/images/circle-logo3.webp",
    },
    {

      img: "/assets/images/circle-logo4.webp",
    },
    {

      img: "/assets/images/circle-logo5.webp",
    },

    {

      img: "/assets/images/circle-logo2.webp",
    },
    {

      img: "/assets/images/circle-logo3.webp",
    },
    {

      img: "/assets/images/circle-logo4.webp",
    },

  ];


  const testimonialData = [
    {
      rating: 5,
      text: "Recommended by friends and found out it is truly one of the best place to rent bins. The price is reasonable, the staff are very friendly and the service is fantastic. I highly recommend it for your next project.",
      img: "/assets/images/sophie-img1.webp",
      name: "Zem Hagos",
      // des: "Property Manager"
    },
    {
      rating: 5,
      text: "So smooth and very nice. Answered all my questions promptly! Would recommend this company to anyone! I had to call i email and even had more questions when they arrived. Not once did the seem at all annoyed.",
      img: "/assets/images/sophie-img1.webp",
      name: "Kimberlee Matwie",
      // des: "Homeowner"
    },
    {
      rating: 5,
      text: "Great service and hassle-free experience! Shivam and his team were professional, and the dumpster was delivered and picked up on time. Pricing was fair, and the whole process was smooth. Highly recommend for anyone needing a reliable dumpster rental!",
      img: "/assets/images/sophie-img1.webp",
      name: "Yuvraj Khera",
      // des: "Head Contractor"
    },
    {
      rating: 5,
      text: "Big Bin Rentals has been our go-to for corporate bin services in Edmonton. Their professional approach and flexible terms make them a valuable partner for our waste management needs.",
      img: "/assets/images/sophie-img1.webp",
      name: "Emily Cale",
      // des: "Homeowner"
    },

    {
      rating: 5,
      text: "Big Bin Rentals is solid! The bin showed up on time, was clean, and got the job done perfectly. Customer service was super easy to deal with—no BS or hidden charges. If you need a bin, these guys are the way to go!",
      img: "/assets/images/sophie-img1.webp",
      name: "Kiran Venugopal",
      // des: "Homeowner"
    },


    //    {
    //   rating: 5,
    //   text: "We recently used big bin services for their 20 yard dumpster, and we couldn't be more impressed! The condition of the bins was excellent clean and well maintained. Their customer service is outstanding, always responsive and helpful. They even provide accurate estimated times for both drop-off and pick-up, which made the entire process seamless. Highly recommend their reliable and professional services!",
    //   img: "/assets/images/sophie-img1.webp",
    //   name: "Headlights To Backlights",
    //   // des: "Homeowner"
    // },

    {
      rating: 5,
      text: "I chose their services based on a recommendation from a friend, and I couldn't be more satisfied. The communication was seamless, and the rental process was completely hassle-free. Their pricing and terms were straightforward and clearly explained.",
      img: "/assets/images/sophie-img1.webp",
      name: "Raw Melody",
      // des: "Homeowner"
    },

  ];


  const homeChooseData = {
    title: "Why Choose Us",
    subtitle: "Choose Big Bin Rentals for fast delivery, transparent pricing, and dependable service making every cleanup simple, affordable, and stress-free.",
    items: [
      {
        icon: "/assets/images/choose-icon1.webp",
        title: "Reliable Service",
        desc: "Ensure smooth waste removal with our punctual delivery and pickup, keeping your project running without delays."
      },
      {
        icon: "/assets/images/choose-icon2.webp",
        title: "Affordable Pricing",
        desc: "Save more with our transparent, budget-friendly rates designed to suit every residential, commercial, or construction need."
      },

      {
        icon: "/assets/images/choose-icon3.webp",
        title: "Variety of Sizes",
        desc: "Choose from multiple dumpster sizes tailored to handle anything from small cleanups to large-scale debris."
      },


      {
        icon: "/assets/images/choose-icon4.webp",
        title: "Eco-Friendly Disposal",
        desc: "Protect the environment with our responsible recycling and waste management practices that minimize landfill impact."
      },


      {
        icon: "/assets/images/choose-icon5.webp",
        title: "Flexible Scheduling",
        desc: "Enjoy hassle-free service with dumpster delivery and pickup options that perfectly match your project timeline."
      },



      {
        icon: "/assets/images/choose-icon6.webp",
        title: "Expert Support",
        desc: "Get guidance from our knowledgeable team to select, schedule, and manage your dumpster rental with ease."
      },
    ]
  };



  // const methodData = {
  //   heading: "home interior-design planning process (HIDPP)",
  //   processSteps: [
  //     {
  //       left: {
  //         count: "01",
  //         title: "Identify the type of clean-out you need to do. This will help you choose the right dumpster size.",
  //       },
  //       right: {
  //         count: "02",
  //         title: "Give us a call to place your request for renting a dumpster. We can help you pick a good size.",

  //       },
  //     },

  //     {
  //       left: {
  //         count: "03",
  //         title: "Identify the type of clean-out you need to do. This will help you choose the right dumpster size.",

  //       },
  //       right: {
  //         count: "04",
  //         title: "Give us a call to place your request for renting a dumpster. We can help you pick a good size.",
  //       },
  //     },

  //     {
  //       left: {
  //         count: "05",
  //         title: "Identify the type of clean-out you need to do. This will help you choose the right dumpster size.",
  //       },
  //       right: {
  //         count: "06",
  //         title: "Give us a call to place your request for renting a dumpster. We can help you pick a good size.",
  //       },
  //     },

  //     {
  //       left: {
  //         count: "07",
  //         title: "Identify the type of clean-out you need to do. This will help you choose the right dumpster size.",
  //       },
  //       right: {
  //         count: "08",
  //         title: "Give us a call to place your request for renting a dumpster. We can help you pick a good size.",
  //       },
  //     },

  //     {
  //       left: {
  //         count: "09",
  //         title: "Identify the type of clean-out you need to do. This will help you choose the right dumpster size.",
  //       },
  //       right: {
  //         count: "10",
  //         title: "Give us a call to place your request for renting a dumpster. We can help you pick a good size.",
  //       },
  //     },
  //   ],
  // };

  const faqs = [
    {
      question: "What is a dumpster rental?",
      answer: `A dumpster rental is a service that provides you with a large metal container, or “dumpster,” which you can use to dispose of trash and debris during a project. Whether you’re cleaning up at home, renovating, or working on a commercial jobsite, we’ll deliver the dumpster to you, and then pick it up once you’re done.`,
    },
    {
      question: "Why should I rent a dumpster?",
      answer: `Renting a dumpster is an efficient and convenient way to manage waste during any project. It’s perfect for tasks such as home cleanouts, remodeling, commercial renovations, or landscaping. By using a dumpster, you can keep your workspace organized and reduce the hassle of multiple trips to the landfill.`,
    },
    {
      question: "How does renting a dumpster work?",
      answer: `Renting a dumpster with us is quick and easy. Simply place your order online or by phone, and we will schedule a delivery that works best for you. We’ll drop the dumpster at your location, and when you’re done, you can request a pickup online. Our driver will then collect the full dumpster at your convenience.`,
    },
    {
      question: "Can I rent more than one dumpster at a time?",
      answer: `Yes, you can rent as many dumpsters as your project requires. Depending on availability, we can deliver multiple dumpsters at once, or stagger them to suit your timeline. We can even deliver dumpsters to multiple job sites if needed.`,
    },
    {
      question:
        "Do I need a permit to use a dumpster?",
      answer: ` You may need a permit to use a dumpster, especially if it’s placed on public property, such as the street or sidewalk. Check with your local city officials to find out if a permit is required. In some cases, you may also need a permit even for dumpsters placed on private property like a driveway or job site. For more details, consult our guide on dumpster permits.`,
    },
  ];


  const Featuredata = [
    {
      img: "/assets/images/checkout-img1.webp",
      number: "001",
      title: "Checkout Our Pricing",
      link: "/pricing/",
    },
    {
      img: "/assets/images/book-image-icon.webp",
      number: "002",
      title: "How to Book <br>  dumpster",
      link: "/how-to-book-a-bin/",
    },
    {
      img: "/assets/images/prohibited-icon-image.webp",
      number: "003",
      title: "Prohibited <br /> items",
      link: "/prohibited-items/",
    }
  ];
  return (
    <>
      <HomeBanner />
      <HomeBooking />
      {/* <HomeAbout /> */}
      <HomeServices data={HomeService} />
      {/* <HomeDumping /> */}
      <PricingSustainbilty extraClass="home-pricing" />
      <HomeSolutions />
      <HomeWork data={homeWorkData} />
      {/* <HomeWorks methodData={methodData} /> */}
      {/* <HomeRentals data={rentalsData} /> */}
      <HomeCircleLogos data={CircleLogos} />
      <HomeTestimonial data={testimonialData} />
      <HomeChoose data={homeChooseData} />
      <HomeLogos />
      <HomeInsight initialData={initialData} />
      <HomeLocation />
      <HomeFaq faqs={faqs} />
      <ServiceFeatures data={Featuredata} extraClass="home-featured" />

    </>
  )
}
